import { createCookie, eraseCookie, readCookie } from '@paragon/client-tools';

const DEV_TOOLS_COOKIE = '__ENABLE_PARAGON_DEVTOOLS';

const ENABLED_FLAG = '__ENABLED';

export function isReduxDevToolsEnabled() {
  return readCookie(DEV_TOOLS_COOKIE) === ENABLED_FLAG;
}

export function toggleReduxDevTools(reload = true) {
  if (isReduxDevToolsEnabled()) {
    eraseCookie(DEV_TOOLS_COOKIE, { domainSpecific: true });
  } else {
    createCookie(DEV_TOOLS_COOKIE, ENABLED_FLAG, { domainSpecific: true });
  }

  if (reload) {
    window.location.reload();
  }
}
